export enum IconNoticeType {
    Gdpr,
    Basic,
    Error,
    Warning,
    Success,
}
